module.exports = __webpack_public_path__ + "20221216:03503e97ddf972ec7716/img/featured_image@2x.94c4140.jpg";